export default __webpack_public_path__ + "static/media/bcfnz-prsa-logo-fullcolour-rgb.86d49ddd.svg";